import colors from '@/utils/colors';

const {
  ratingVeryUnsatisfiedColor,
  ratingUnsatisfiedColor,
  ratingNeutralColor,
  ratingSatisfiedColor,
  ratingVerySatisfiedColor,
} = colors;

const CSAT_RATING = {
  VERY_UNSATISFIED: {
    value: 1,
    label: 'Muito insatisfeito',
    color: ratingVeryUnsatisfiedColor,
  },
  UNSATISFIED: {
    value: 2,
    label: 'Pouco insatisfeito',
    color: ratingUnsatisfiedColor,
  },
  NEUTRAL: {
    value: 3,
    label: 'Neutro',
    color: ratingNeutralColor,
  },
  SATISFIED: {
    value: 4,
    label: 'Pouco satisfeito',
    color: ratingSatisfiedColor,
  },
  VERY_SATISFIED: {
    value: 5,
    label: 'Muito satisfeito',
    color: ratingVerySatisfiedColor,
  },
};

export default {
  methods: {
    normalizeRatingFromSeries(response) {
      for (const [, value] of Object.entries(response)) {
        if (!Array.isArray(value)) {
          continue;
        }
        value.forEach(prop => {
          if (!prop instanceof Object) {
            return;
          }

          if (Array.isArray(prop.values)) {
            prop.values = prop.values.map(value => this.getRatingLabel(value));
          }
        });
      }
      return response;
    },
    getRatingColor(value) {
      for (const rating in CSAT_RATING) {
        if (CSAT_RATING.hasOwnProperty(rating) && CSAT_RATING[rating].value === value) {
          return CSAT_RATING[rating].color;
        }
      }
    },
    getRatingLabel(value) {
      for (const rating in CSAT_RATING) {
        if (CSAT_RATING.hasOwnProperty(rating) && CSAT_RATING[rating].value === value) {
          return CSAT_RATING[rating].label;
        }
      }
    },
    getRatingObj(value) {
      return {
        name: this.getRatingLabel(value),
        color: this.getRatingColor(value),
      };
    },
  },
};
